import { call, takeLatest } from 'redux-saga/effects';
import { logApiEvents, logUserEvents } from '@store/actions/analytics.action';
import { EventLog } from '@types';
import { accessTokenObj } from '@utils/auth.config';
import { logUserEvent, logAPIEvent as ApiEvent, EventLog as CommonLog, logFullStoryEvent } from 'fmc-digital-common';

const constructEvent = (payload: any) => {
    const token: any = accessTokenObj();

    const timestamp = Date.now().toString();
    const eventTime = new Date().toISOString();

    payload.attributes = {
        timestamp,
        eventTime,
        date: `${new Date()}`,
        application: 'AuthCustomerSrvApp',
        userID: token?.sub,
        uuid: token?.uuid,
        ...payload.attributes
    };
    return payload;
};

function callAmplify(event: any) {
    logUserEvent(event);
}

export function* recordUserEventWorker(action: ReturnType<typeof logUserEvents>) {
    try {
        const event: CommonLog = yield call(constructEvent, action.payload);
        console.log('---UserEvent----', event);
        yield call(callAmplify, event);
        yield call(logFullStoryEvent, event);
    } catch (error) {
        console.log(error);
    }
}

export function* recordApiEventWorker(action: any) {
    try {
        const event: EventLog = yield call(constructEvent, action.payload);
        console.log('---ApiEvent----', event);
        ApiEvent(event as unknown as CommonLog);
    } catch (error) {
        console.log(error);
    }
}

export default function* root() {
    yield takeLatest(logUserEvents, recordUserEventWorker);
    yield takeLatest(logApiEvents, recordApiEventWorker);
}
